<script>
  import { Username } from "./store.js";
</script>

<form action="" class="box">
  <h1 class="title is-4">Username Found</h1>
  <p>
    Your username is
    <strong>{$Username.value}</strong>
  </p>
  <div style="text-align: right; margin-top: 15px;">
    <a href="/signin/{$Username.value}" class="button is-purple">Login to eAdmissions</a>
  </div>

  <p style="margin-top: 30px;">
    If you do not remember your password, please reset it below.
  </p>

  <div style="text-align: right; margin-top: 15px;">
    <a href="/account/resetoptions" class="button">Forgot Password</a>

  </div>
</form>
